import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const Gamou = () => {
  return <DynamicPageRenderer slug="evenements/gamou" />;
};

export default Gamou;
